<script setup>
import { useSlots } from 'vue';
import { FolderOpen } from '@lucide/vue';

defineProps({
  title: {
    type: String,
    default: 'Belum Ada Data',
  },
  description: {
    type: String,
    default: 'Data yang Anda cari belum tersedia saat ini.',
  },
  icon: {
    type: [Object, Function],
    default: FolderOpen,
  },
});

const slots = useSlots();
</script>

<template>
  <div class="p-8 text-center rounded-2xl border border-dashed border-slate-200 bg-slate-50/50 flex flex-col items-center justify-center">
    <div class="w-12 h-12 rounded-2xl bg-slate-100 text-slate-400 flex items-center justify-center mb-3 border border-slate-200/60">
      <component :is="icon" class="w-6 h-6" />
    </div>
    <h4 class="text-sm font-bold text-slate-800">{{ title }}</h4>
    <p class="text-xs text-slate-500 mt-1 max-w-sm leading-relaxed">{{ description }}</p>
    <div v-if="slots.action" class="mt-4">
      <slot name="action" />
    </div>
  </div>
</template>
